import { buildStaticViewColumn } from './utils';

// eslint-disable-next-line import/prefer-default-export
export const modifyColumns = (defaultedColumns = []) =>
  defaultedColumns.map((column) =>
    buildStaticViewColumn({
      ...column
    })
  );
